import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentSSR',
  setup(__props, { expose }) {

async function scrollToTop(duration = 0, behavior: 'smooth' | 'auto' = 'smooth'): Promise<void> {
	if (globalThis.window != null) {
		const contentHeader = document.querySelector('#content-header');
		const top = contentHeader?.getBoundingClientRect().height ?? 0;

		if (window.scrollY > top) {
			setTimeout(() => {
				window.scroll({ top, behavior });
			}, duration);

			return new Promise((resolve, reject) => {
				const failed = setTimeout(() => {
					reject(new Error('[ContentSSR]: `scrollToTop` timeout failure.'));
				}, 3000);

				const scrollHandler = () => {
					if (window.scrollY === top) {
						window.removeEventListener('scroll', scrollHandler);
						clearTimeout(failed);
						resolve();
					}
				};

				if (window.scrollY === top) {
					clearTimeout(failed);
					resolve();
				} else {
					window.addEventListener('scroll', scrollHandler);
				}
			});
		}
	}
}
expose({ scrollToTop });

return { __sfc: true,scrollToTop }
}

})